window.addEventListener("load", function(){

    var filterPerPage    = $("#nb_per_page");

    var fullSelect         = $("#full_check");
    var choiceCheckTable   = $(".choice_check_table");
    var actionsTableSubmit = $("#actions__table_submit");
    var actionsTableSelect = $("#actions__table_select");
    var hiddenTicketIds    = $("#hidden_print_ids");
    var actionsTableForm   = $("#actions__table_form");

    // function changedFullSelect(e){
    //     if ($(this).is(":checked")) {
    //         choiceCheckTable.is(":checked");
    //     }
    //     else{
    //         choiceCheckTable.is(":unchecked");
    //     }
    //
    //     updateCount();
    // }

    function changedFullSelect(e){
        if ($(this).is(":checked")) {
            choiceCheckTable.prop('checked', true);
        }
        else{
            choiceCheckTable.prop('checked', false);
        }

        updateCount();
    }

    function changedSelect(e){
        updateCount();
    }

    function updateCount(){
        var tableSelected = $(".actions__table_selected");
        var tableSelectedToast = $(".c-action-bar--hidded");

        if(tableSelected.hasClass("table__orders") || tableSelected.hasClass("table__tickets")){
            if ($(".choice_check_table:checked").length > 0) {
                tableSelected.html("<strong>" + $(".choice_check_table:checked").length + "</strong> sélectionnée(s)");
                tableSelectedToast.addClass("is-active");
            }
            else {
                tableSelectedToast.removeClass("is-active");
            }
        }
        else{
            tableSelected.html("<strong>" + $(".choice_check_table:checked").length + "</strong> sélectionné(s)");
        }


    }

    function changeActionForm(e){
        e.preventDefault();

        var url = $(this).val();

        if(url == '-1' || url == -1){
            actionsTableForm.attr('action', "");
        }
        else{
            actionsTableForm.attr('action', url);
        }
        if($(this).find(":selected").data('option') == "modalPost") {
            actionsTableForm.attr('data-rel', 'post-modal');
        } else {
            actionsTableForm.removeAttr('data-rel');
        }
        if($(this).find(":selected").attr('target')) {
            actionsTableForm.attr('target', $(this).find(":selected").attr('target'));
        } else {
            actionsTableForm.removeAttr('target');
        }

    }

    function sendAction(e){
        e.preventDefault();

        if($("#actions__table_form").attr("action") === ""){
            return false;
        }

        // Pas de soumission : l'archive des factures se prépare dans la modale du pro v2.
        if(actionsTableSelect.find(":selected").data('option') == "invoicesArchive"){
            var orderIdentifiers = [];
            $('.choice_check_table:checked').each(function() {
                if($(this).data('identifier')){
                    orderIdentifiers.push($(this).data('identifier'));
                }
            });
            window.YP.Prov2Communication().openOrderInvoicesArchiveModal(window.parent, { orderIdentifiers: orderIdentifiers });
            return false;
        }

        var ids = "";
        $('.choice_check_table:checked').each(function() {
            ids += $(this).val() + ",";
        });

        ids = ids.slice(0,-1);

        hiddenTicketIds.val(ids);
        actionsTableForm.submit();
    }

    if(fullSelect.length > 0 && choiceCheckTable.length > 0 && actionsTableSubmit.length > 0 &&  actionsTableSelect.length > 0){
        actionsTableForm.off("submit");
        choiceCheckTable.on("change", changedSelect);
        fullSelect.on("change", changedFullSelect);
        actionsTableSelect.on("change", changeActionForm);
        actionsTableSubmit.on("click", sendAction);
    }

});
